var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"hide-header":"","size":"lg","body-bg-variant":"dark","hide-footer":""},scopedSlots:_vm._u([{key:"modal-footer",fn:function(){return [_c('div')]},proxy:true}])},[_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","src":"https://player.vimeo.com/video/470464170"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }